export default __webpack_public_path__ + "e62452b3dac0499c3da67b8cd693b0d7.png";